import { render, staticRenderFns } from "./QLeaderboardDataTable.vue?vue&type=template&id=80f30eb6&scoped=true&"
import script from "./QLeaderboardDataTable.vue?vue&type=script&lang=js&"
export * from "./QLeaderboardDataTable.vue?vue&type=script&lang=js&"
import style0 from "./QLeaderboardDataTable.vue?vue&type=style&index=0&id=80f30eb6&prod&lang=css&"
import style1 from "./QLeaderboardDataTable.vue?vue&type=style&index=1&id=80f30eb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f30eb6",
  null
  
)

export default component.exports